module.exports = __webpack_public_path__ + "static/img/mainstream.5dd937f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainstream.png
// module id = 3IbY
// module chunks = 0